module.exports = __webpack_public_path__ + "img/storage.e5b298bb.svg";